import { render, staticRenderFns } from "./QQQuestionario.vue?vue&type=template&id=3c8c6a50&scoped=true&"
import script from "./QQQuestionario.vue?vue&type=script&lang=js&"
export * from "./QQQuestionario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8c6a50",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm});
